class TreatmentMedicineService {
  static WEGOVY_ID = '18';

  static isWegovy(treatmentMedicineId: string): boolean {
    return this.WEGOVY_ID === treatmentMedicineId;
  }

  static isNewMedicine(treatmentMedicineId: string): boolean {
    return this.isWegovy(treatmentMedicineId);
  }
}

export default TreatmentMedicineService;
